import { render } from "./AposCellBasic.vue?vue&type=template&id=453e6504"
import script from "./AposCellBasic.vue?vue&type=script&lang=js"
export * from "./AposCellBasic.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ui/ui/apos/components/AposCellBasic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "453e6504"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('453e6504', __exports__)) {
    api.reload('453e6504', __exports__)
  }
  
  module.hot.accept("./AposCellBasic.vue?vue&type=template&id=453e6504", () => {
    api.rerender('453e6504', render)
  })

}


export default __exports__